import { render, staticRenderFns } from "./categoriesSelector.vue?vue&type=template&id=4402f9e2"
import script from "./categoriesSelector.vue?vue&type=script&lang=js"
export * from "./categoriesSelector.vue?vue&type=script&lang=js"
import style0 from "./categoriesSelector.vue?vue&type=style&index=0&id=4402f9e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports